const withBypassComponent = function (Component) {
  let enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (enabled) {
    return Component;
  }
  return _ref => {
    let {
      children
    } = _ref;
    return children;
  };
};
export { withBypassComponent };
//# sourceMappingURL=withBypassComponent.js.map